// Constants for ChatInterface

export const FILE_TOKEN_GROUP_I18N_STRINGS = {
    removeFileAriaLabel: (index: number) => `Remove file ${index + 1}`,
    limitShowFewer: 'Show fewer files',
    limitShowMore: 'Show more files',
    errorIconAriaLabel: 'Error',
    warningIconAriaLabel: 'Warning',
};

export const INITIAL_UI_STATE = {
    input_enabled: false,
    input_placeholder: 'Connecting...',
    show_file_upload: false,
    show_progress: false,
    chips: []
};

export const INITIAL_GREETING_CHIPS = [
    {
        id: 'start_questionnaire',
        text: '📝 Answer Questions',
        action: 'start_questionnaire',
        value: 'questionnaire'
    },
    {
        id: 'upload_excel',
        text: '📁 Upload Excel File',
        action: 'upload_excel',
        value: 'upload'
    }
];
